/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(false)
    export class DesignBOMDialog extends _Ext.EditorDialogBase<DesignBOMRow> {
        protected getLocalTextPrefix() { return DesignBOMRow.localTextPrefix; }

        protected form = new DesignBOMForm(this.idPrefix);
        protected getFormKey() { return DesignBOMForm.formKey; }
         
        protected get_ExtDialogOptions() {

            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            opt.ShowSaveAndNewButtonInToolbar = true;
            return opt;
        }

        UseKaratWiseRate: boolean = false;
        IsConfigurable: boolean = false;
        BOMMaster: any;

        constructor() {
            super();

            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight); 
            //q.setTextRightAlign(this.form.BomAmount);
            //q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.PureWeight);

            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));


            // On Data Change
            this.form.ItemTypeId.changeSelect2(e => {
                var item = Q.toId(this.form.ItemTypeId.value);
                this.setFields();
            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.value = "";
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    this.setFields();
                }
            });


            this.form.CategoryId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.setFields();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
            })

            //this.form.BomRate.change(e => {
            //    var calcon = this.form.CalcOnId.value;
            //    if (calcon == "4" || calcon == "5")
            //        if (this.form.ItemTypeId.value == 104) {
            //            if (this.UseKaratWiseRate == true)
            //                this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
            //            else
            //                this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
            //        }
            //        else {
            //            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
            //        }
            //    if (calcon == "3")
            //        this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

            //});
            this.form.Pieces.changeSelect2(e => {
                if (!isNaN(this.form.Pieces.value) && !isNaN(this.form.Weight.value))  
                    this.form.PointerWeight.value = this.form.Weight.value / this.form.Pieces.value;

                
            });

            this.form.Weight.change(e => {
                //var calcon = this.form.CalcOnId.value;
                //if (calcon == "4" || calcon == "5")
                //    if (this.form.ItemTypeId.value == 104) {
                //        //if (this.UseKaratWiseRate == true)
                //        //    this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                //        //else
                //        //    this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                //    }
                //    else {
                //        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                //    }
                //if (calcon == "3")
                //    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                if (!isNaN(this.form.Purity.value)){
                    this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
                }
                if (!isNaN(this.form.Pieces.value) && !isNaN(this.form.Weight.value))  
                    this.form.PointerWeight.value = this.form.Weight.value / this.form.Pieces.value;

            });

            this.form.CalcOnId.changeSelect2(e => {
                var calcon = this.form.CalcOnId.value;
                //if (calcon == "4" || calcon == "5")
                //    if (this.form.ItemTypeId.value == 104) {
                //        if (this.UseKaratWiseRate == true)
                //            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                //        else
                //            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                //    }
                //    else {
                //        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                //    }
                //if (calcon == "3")
                //    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;
                
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                //this.GetRate();                
            });

            this.form.MetalColorId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
            });

            this.form.ShapeId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                //this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                var GroupSieve = AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                this.form.GroupSieveId.value = GroupSieve ;
                //this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                //this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                //this.GetRate();
            });
             
            this.form.BOMDesignId.changeSelect2(e => {
                var DesignTypeId = Q.toId(this.form.ProductTypeId.value);
                if (DesignTypeId == null) {
                    Q.notifyWarning("Select Item Type")
                    this.form.BOMDesignId.value = "";
                    this.form.ProductTypeId.element.attr("tabindex", 1);
                }
                else {

                    var DesignID = Q.toId(this.form.BOMDesignId.value);
                   
                    var Component: OMS.RawMaterialMasterRow;

                    OMS.RawMaterialMasterService.Retrieve({ EntityId: DesignID }, response => Component = response.Entity, { async: false });


                    this.form.Weight.value = 0;
                    this.form.Pieces.value = 0;

                    if (Component != null) {
                        this.form.ProductCode.value = Component.ProductCode;

                        this.form.CategoryId.value = Component.CategoryId.toString();
                        this.form.SubCategoryId.value = Component.SubCategoryId.toString();
                        this.form.ProductTypeId.value = Component.ProductTypeId.toString();
                        this.form.ItemType.value = Component.ItemType; 
                        this.form.CalcOnId.value = Component.CalcOnId.toString();
                        if (this.form.ItemTypeId.value == 104) {
                            var std = Component.Purity;
                            this.form.Purity.value = std;
                            this.form.MetalColorId.value = Component.MetalColorId.toString();
                            this.form.KaratId.value = Component.KaratId.toString();
                            this.form.ItemType.value = Component.ItemType;
                        }

                        if (this.form.ItemTypeId.value == 105) {
                            this.form.ShapeId.value = Component.ShapeId.toString();
                            this.form.StoneColorId.value = Component.StoneColorId.toString();
                            this.form.QualityId.value = Component.QualityId.toString();
                            this.form.ItemType.value = Component.ItemType;
                        }
                        this.IsConfigurable = Component.IsConfigurable;
                        this.setFields();
                        //this.GetRate();
                    }
                }

            });

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;

            });

            // Validate Purity
            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                if (KaratId != null) {
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    min = purity.MinPurity;
                    max = purity.MaxPurity;
                    std = purity.StdPurity;
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                        this.form.Purity.value = std;
                    }
                }

            });

        }

        afterLoadEntity() {
            super.afterLoadEntity();
            this.BOMMaster = (this.parentEditor.parentDialog as DesignDialog);
            var Component: OMS.RawMaterialMasterRow;
            if (!Q.isEmptyOrNull(this.form.BOMDesignId.value)) {
                OMS.RawMaterialMasterService.Retrieve({ EntityId: this.form.BOMDesignId.value }, response => Component = response.Entity, { async: false });
                this.IsConfigurable = Component.IsConfigurable;
            }
        
            this.setFields();
             

        }

        protected setFields() {

            switch (this.form.ItemTypeId.value) {

                case 105: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight);
                    q.showAndSetRequiredField(this.form.Pieces);
                    q.showAndEnableField(this.form.PointerWeight);
                    q.showAndEnableField(this.form.CenterStone);
                    q.showAndSetRequiredField(this.form.SettingId);
                    q.showAndSetRequiredField(this.form.Weight);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.ShapeId) : q.showAndDisableField(this.form.ShapeId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.QualityId) : q.showAndDisableField(this.form.QualityId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.StoneColorId) : q.showAndDisableField(this.form.StoneColorId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.StoneSizeId) : q.showAndDisableField(this.form.StoneSizeId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.SieveId) : q.showAndDisableField(this.form.SieveId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.CategoryId) : q.showAndDisableField(this.form.CategoryId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.SubCategoryId) : q.showAndDisableField(this.form.SubCategoryId);                   

                    switch (parseInt(this.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth); 
                            //q.hideEditorCategory(this.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndSetRequiredField(this.form.StoneCutId);
                            q.showAndSetRequiredField(this.form.StonePolishId);
                            q.showAndSetRequiredField(this.form.StoneSymmetryId);
                            q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                            q.showAndSetRequiredField(this.form.StoneCuletId);
                            q.showAndSetRequiredField(this.form.StoneGirdleId);
                            q.showAndSetRequiredField(this.form.StoneTable);
                            q.showAndSetRequiredField(this.form.StoneDepth); 
                            q.showAndSetRequiredField(this.form.Pieces);                           
                            //q.showAndSetRequiredField(this.form.Lab);

                            break;
                        default:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth); 
                            break;

                    }

                    break;
                }
                case 104: {
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.KaratId) : q.showAndDisableField(this.form.KaratId);
                    this.IsConfigurable == true ? q.showAndSetRequiredField(this.form.MetalColorId) : q.showAndDisableField(this.form.MetalColorId);
                    q.showAndSetRequiredField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    q.hideField(this.form.PointerWeight);
                    q.hideField(this.form.CenterStone);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.SettingId);
                    q.hideField(this.form.GroupSieveId);
                    break;
                }

                default: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    break;
                }
            }
        } 
    }
}